<form *ngIf="form" [formGroup]="form" (ngSubmit)="createEntity()">
  <dx-text-box formControlName="code" [label]="'common.code' | translate | ucfirst" formField required></dx-text-box>
  <dx-text-box formControlName="name" formField required></dx-text-box>
</form>
